import { Component, ChangeDetectionStrategy, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';

import { ProductDialogComponent } from '../product-dialog';
import { LoyaltyProgramReadService, LoyaltyProgramPermService, ResultDialogService } from '../services';

@Component({
  selector: 'lp-own-products',
  templateUrl: './lp-own-products.component.html',
  styleUrls: ['./lp-own-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpOwnProductsComponent extends BaseResizableComponent {
  public readonly permService = inject(LoyaltyProgramPermService);
  private readonly loyaltyProgramReadService = inject(LoyaltyProgramReadService);
  private readonly resultDialogService = inject(ResultDialogService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);
  private readonly router = inject(Router);

  readonly products$ = this.loyaltyProgramReadService.ownProducts$;

  loading = true;
  appending = false;
  hasMore = true;

  override ngOnInit(): void {
    super.ngOnInit();

    const scrollEl = document.getElementById('own-products-scrollbar');

    this.refresh();

    this.products$.pipe(takeUntil(this.destroyed$$)).subscribe(({ items, hasMore }) => {
      this.loading = !items;
      this.appending = false;
      this.hasMore = hasMore;

      if (hasMore && scrollEl) {
        setTimeout(() => {
          const { clientHeight, scrollHeight } = scrollEl;
          if (clientHeight === scrollHeight) {
            this.onScroll();
          }
        });
      }

      this.cdr.markForCheck();
    });
  }

  addProduct() {
    this.dialogService
      .open<void | string>(new PolymorpheusComponent(ProductDialogComponent, this.injector), {
        dismissible: false,
        closeable: false,
      })
      .subscribe(id => {
        if (id) {
          this.resultDialogService.open({ type: 'added' }).subscribe({
            complete: () => {
              this.router.navigate(['/loyalty', 'product', id]);
            },
          });
        }
      });
  }

  refresh() {
    this.loading = true;
    this.cdr.markForCheck();

    this.loyaltyProgramReadService.getOwnProducts();
  }

  onScroll() {
    if (!this.appending && this.loyaltyProgramReadService.isOwnProductsHasMore) {
      this.appending = true;
      this.cdr.markForCheck();

      this.loyaltyProgramReadService.getOwnProducts(true);
    }
  }
}
